module.exports = __webpack_public_path__ + "img/rms2.23f37764.jpg";